import React, { Component } from 'react'
import { Link, browserHistory } from 'react-router'
import { NavDropdown, MenuItem, Navbar, Collapse, NavItem, Accordion, Panel, DropdownButton} from 'react-bootstrap'
import MenuItemView from '../../../containers/Sections/Menu/item'
import { translate } from "react-translate"
import { reserchAndConsultancyUrl, corporativeServicesUrl } from '../../../constants'

import './Menu.scss';

@translate("MenuLandings")
class MenuLandings extends Component {

  constructor(props) {
    super(props);

    this.state = {
      open: false,
      expanded:false,
      collapse:false
     }

    this.openMenu = this.openMenu.bind(this)
  }

   openMenu() {
    this.setState({open: !this.state.open});
  }

  render(){

    const { onSelectOffice, t, offices } = this.props;

    const landings = [
      { id: '3', name: t('Locales'), url: '/locales' },
      { id: '2', name: t('Industrias'), url: '/industrias' },
      // HIDE-HOTELS { id: '13', name: t('Hoteles'), url: '/hoteles' },
      { id: '9', name: t('Campos'), url: '/campos' },
      { id: '8', name: t('Emprendimientos'), url: '/emprendimientos' },
      { id: '7', name: t('Terrenos'), url: '/terrenos' }
    ];

    const pathname = window.location.pathname
    const classResidential = (pathname === '/residencial') ? 'actual-land' : '';
    const classOffices = (pathname === '/oficinas') ? 'actual-land' : '';
    return (
      <Navbar className='ljr-main-menu' inverse defaultExpanded={this.state.expanded}>
        <div className="responsive-divisions-menu menu-responsive-fix visible-xs-inline-block">
          <NavDropdown eventKey="4" title="Nuestras Divisiones" id="nav-responsive">
            <DropdownButton className="dropdown-subsidiaries-invention" title={t("Residencial")} id="residential-dropdown">
              {offices.map((item, index) =>
                <MenuItem key={index} eventKey={index} href={item.url} onClick={() => onSelectOffice(item)}><Link to={item.url} className="fixClick">{item.title}</Link></MenuItem>
              )}
            </DropdownButton>
            <DropdownButton className="dropdown-subsidiaries-invention" title={t("Oficinas")} id="offices-dropdown">
              <MenuItem key={1} eventKey={1} href={'/oficinas'}>
                <Link to={'/oficinas'} className="fixClick">Propiedades</Link>
              </MenuItem>
              <MenuItem key={2} eventKey={2} href={corporativeServicesUrl}>
                <Link target="_blank" href={corporativeServicesUrl} className="fixClick">Property Management</Link>
              </MenuItem>
            </DropdownButton>
            {landings.map((item, index) =>
              <MenuItem key={index} href={item.url}><Link to={item.url} className="fixClick">{item.name}</Link></MenuItem>
            )}
            <MenuItem key={'reserarch-consultancy'} to={'/consultancy-research'}>{t('ConsultoriaResearch')}</MenuItem>
            <MenuItem key="tasaciones-option" to="/tasaciones" className="tasaciones-option"><Link to="/tasaciones" className="fixClick">{t("Tasaciones")}</Link></MenuItem>
          </NavDropdown>
        </div>
        <Navbar.Toggle />
        <Navbar.Collapse>
          <ul className="nav nav-justified navbar-landings">
            <NavDropdown className={classResidential + ' lj-nav-item'} eventKey="4" title={t("Residencial")} id="nav-dropdown" onClick={(e) => this._onClickDropDown(e, "/residencial")} >
              {offices.map((item, index) =>
                 <MenuItem key={index} eventKey={index} onClick={() => onSelectOffice(item)}><Link to={item.url}>{item.title}</Link></MenuItem>
              )}
            </NavDropdown>
            <NavDropdown className={classOffices + ' lj-nav-item'} eventKey="5" title={t("Oficinas")} id="nav-dropdown" onClick={(e) => this._onClickDropDown(e, "/oficinas")} >
              <MenuItem key={1} eventKey={1}>
                <Link to={'/oficinas'}>Propiedades</Link>
              </MenuItem>
              <MenuItem key={2} eventKey={2} target="_blank" href={corporativeServicesUrl}>
                {t('ServiciosCorporativos')}
              </MenuItem>
            </NavDropdown>
            {landings.map((item, index) =>
              (item.url === pathname) ? (
                <li className="actual-land lj-nav-item" key={index}>
                   <Link className="btn btn-menu" to={item.url}>{item.name}</Link>
                 </li>
              ) : (
                <li className="lj-nav-item" key={index}>
                  <Link className="btn btn-menu" to={item.url}>{item.name}</Link>
                </li>
              )
            )}
            <li className="last-li lj-nav-item">
              <Link className="btn btn-menu" to={'/consultancy-research'}><span className="span-sq">{t('ConsultoriaResearch')}</span></Link>
            </li>
            <li className="last-li lj-nav-item">
              <Link className="btn btn-menu" to="/tasaciones"><span className="span-sq">{t("Tasaciones")}</span></Link>
            </li>
          </ul>
        </Navbar.Collapse>
      </Navbar>
    )
  }

  _onClickDropDownResponsive(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({collapse: !this.state.collapse})
  }

  _onClickDropDown(e, route) {
    this.openMenu()
    e.preventDefault();
    browserHistory.push(route)
  }
}

export default MenuLandings



// WEBPACK FOOTER //
// ./src/features/commons/Menu/Menu.component.js